import { render, staticRenderFns } from "./EventAppointmentDetails.vue?vue&type=template&id=7379fb0a&scoped=true&"
import script from "./EventAppointmentDetails.vue?vue&type=script&lang=js&"
export * from "./EventAppointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventAppointmentDetails.vue?vue&type=style&index=0&id=7379fb0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7379fb0a",
  null
  
)

export default component.exports